module.exports = __webpack_public_path__ + "images/backgrounds/river/medium.d314616e3dc0d1426877.jpg";